import { Theme, styled } from '@mui/material/styles';
import { TableRow } from '@mui/material';

type StylesTypes = {
  theme: Theme;
};

const StyledTableRow = styled(TableRow)(({ theme }: StylesTypes) => ({
  height: '72px',
  boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  transform: 'scale(1)',
  backgroundColor: `${theme.palette.background.default} !important`,
  borderRadius: '16px',
  '& td:first-of-type': {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
  },
  '& td:last-of-type': {
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  '&:hover': {
    backgroundColor: 'transparent !important',
    cursor: 'pointer',
    '.css-civl3-MuiTableCell-root': {
      '&:not(:last-of-type)': {
        color: theme.palette.primary.main,
      },
    },
  },
}));
const tableCell = {
  maxWidth: 'sm',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
};

const tableCellBox = {
  display: 'flex',
  alignItems: 'center',
};

const iconSiteBox = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '14px',
  paddingRight: '10px',
};

const iconAlarmBox = {
  display: 'flex',
  alignItems: 'center',
  paddingRight: '8px',
};

const siteType = {
  textTransform: 'capitalize',
};

export { StyledTableRow, tableCell, tableCellBox, iconSiteBox, iconAlarmBox, siteType };
